import { Tag } from '../interface';

export const formatDetectionTag = new Tag('telephone=no', 'format-detection');
